(function () {
  var IS_TOUCH = matchMedia("(hover: none)").matches || "ontouchstart" in window;
  var CURTAIN_FALLBACK_TIME = 350;
  var CURTAIN_MIN_TIME = 150;
  var LAST_CURTAIN_AT = 0;

  function getRoot() {
    return document.querySelector("media-gallery");
  }

  function getSectionId(root) {
    return root ? root.getAttribute("data-section") : "";
  }

  function getVariants(sectionId) {
    var el = document.querySelector("#onkly-variants-" + sectionId);
    if (!el) return [];
    try { return JSON.parse(el.textContent || "[]"); } catch (e) { return []; }
  }

  function getCurrentVariant(sectionId) {
    var el = document.querySelector("#variants" + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent || "null"); } catch (e) { return null; }
  }

  function getMainSwiper(root) {
    var el = root ? root.querySelector(".product-image__slider") : null;
    return el && el.swiper ? el.swiper : null;
  }

  function getThumbSwiper(root) {
    var el = root ? root.querySelector(".product-thumb__list") : null;
    return el && el.swiper ? el.swiper : null;
  }

  function getSlideIndexByMediaId(root, mediaId) {
    var slides = root.querySelectorAll(".product-image__slider .swiper-slide:not(.swiper-slide-duplicate)");
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute("data-id")) === String(mediaId)) {
        return parseInt(slides[i].getAttribute("data-slide"), 10);
      }
    }
    return -1;
  }

  function forceMainImage(root, variant) {
    if (!root || !variant || !variant.featured_media || !variant.featured_media.id) return;
    var swiper = getMainSwiper(root);
    if (!swiper) return;
    // Look up the live index (may differ from data-slide after rebuild).
    var slideIndex = -1;
    for (var i = 0; i < swiper.slides.length; i++) {
      if (String(swiper.slides[i].getAttribute("data-id")) === String(variant.featured_media.id)) {
        slideIndex = i;
        break;
      }
    }
    if (slideIndex < 0) {
      slideIndex = getSlideIndexByMediaId(root, variant.featured_media.id);
      if (slideIndex < 0) return;
    }
    try {
      swiper.slideToLoop(slideIndex, 0, false);
    } catch (e) {
      try { swiper.slideTo(slideIndex, 0, false); } catch (err) {}
    }
  }

  function getVariantMediaIds(variants) {
    var ids = [];
    variants.forEach(function (v) {
      if (v && v.featured_media && v.featured_media.id) {
        ids.push(String(v.featured_media.id));
      }
    });
    return ids.filter(function (id, i) { return ids.indexOf(id) === i; });
  }

  function updateSwipers(root) {
    try {
      var t = getThumbSwiper(root);
      if (t) { t.update(); t.updateSlides(); t.updateProgress(); t.updateSlidesClasses(); }
      var m = getMainSwiper(root);
      if (m) { m.update(); m.updateSlides(); m.updateProgress(); m.updateSlidesClasses(); }
    } catch (e) {}
  }

  function markThumbsReady(root) {
    if (root) root.classList.add("onkly-thumbs-ready");
  }

  // Curtain is now a real <div> with a CSS animation. iOS Safari sometimes
  // skips ::after transitions when toggled too fast (especially when the new
  // image is already cached and the swap happens in a single frame). A keyframe
  // animation runs its full duration regardless, so the white flash is always
  // visible — which is what hides the t-shirt morph.
  // iOS Safari skips repeated animations on the same DOM node — the only
  // reliable workaround is a fresh element per flash. We also remove it after
  // the animation so the next call has nothing to optimize away.
  // The 250ms guard collapses iOS double-fire change events (label tap +
  // variant-picker re-dispatch) into a single visible flash.
  function showCurtain(root) {
    if (!root) return;
    var now = Date.now();
    if (now - LAST_CURTAIN_AT < 500) return;
    LAST_CURTAIN_AT = now;

    var holder = root.querySelector(".product-images") || root;
    if (!holder) return;

    Array.from(holder.querySelectorAll(".onkly-curtain")).forEach(function (el) { el.remove(); });

    var d = document.createElement("div");
    d.className = "onkly-curtain is-flashing";
    holder.appendChild(d);

    setTimeout(function () { if (d.parentNode) d.remove(); }, 280);
  }

  // No-op kept so old call-sites don't need to change. The animation
  // self-completes; nothing to hide manually.
  function hideCurtain() {}

  function getClickedInput(target) {
    if (!target) return null;
    if (target.matches && target.matches("input[type='radio'], select")) return target;
    var label = target.closest("label");
    if (label) {
      var inside = label.querySelector("input[type='radio']");
      if (inside) return inside;
      var forId = label.getAttribute("for");
      if (forId) {
        var byFor = document.getElementById(forId);
        if (byFor) return byFor;
      }
    }
    return null;
  }

  function getOptionIndex(input, root) {
    if (!input) return -1;
    var holder = input.closest("fieldset, select, .product-form__input");
    if (!holder) return -1;
    var container = document.querySelector("#variant-selects-" + getSectionId(root));
    if (!container) return -1;
    return Array.from(container.querySelectorAll("fieldset, select, .product-form__input")).indexOf(holder);
  }

  function buildFutureOptions(root, clickedInput) {
    var sectionId = getSectionId(root);
    var container = document.querySelector("#variant-selects-" + sectionId);
    if (!container) return [];
    var groups = Array.from(container.querySelectorAll("fieldset, select, .product-form__input"));
    var clickedIndex = getOptionIndex(clickedInput, root);
    return groups.map(function (group, index) {
      if (index === clickedIndex && clickedInput) return clickedInput.value;
      if (group.tagName === "SELECT") return group.value;
      var checked = group.querySelector("input[type='radio']:checked");
      return checked ? checked.value : "";
    }).filter(Boolean);
  }

  function findVariantByOptions(variants, options) {
    if (!variants.length || !options.length) return null;
    return variants.find(function (v) {
      return v && v.options && JSON.stringify(v.options) === JSON.stringify(options);
    }) || null;
  }

  function apply(root, variantOverride) {
    if (!root) return;
    var sectionId = getSectionId(root);
    var variants = getVariants(sectionId);
    var currentVariant = variantOverride || getCurrentVariant(sectionId);

    if (!variants.length || !currentVariant || !currentVariant.featured_media) {
      markThumbsReady(root);
      return;
    }

    var currentMediaId = String(currentVariant.featured_media.id);
    var variantMediaIds = getVariantMediaIds(variants);
    var thumbsWrapper = root.querySelector(".product-thumbnails");
    var thumbs = root.querySelectorAll(".product-thumb__item");

    if (!thumbs.length || !thumbsWrapper) {
      markThumbsReady(root);
      return;
    }

    var extraFound = false;

    thumbs.forEach(function (thumb) {
      var mediaEl = thumb.querySelector("[data-mediaid]");
      if (!mediaEl) return;

      var mediaId = String(mediaEl.getAttribute("data-mediaid"));
      var isVariantMedia = variantMediaIds.indexOf(mediaId) !== -1;

      if (isVariantMedia) {
        if (mediaId === currentMediaId) {
          thumb.classList.remove("onkly-hidden");
          thumb.classList.add("swiper-slide-thumb-active");
        } else {
          thumb.classList.add("onkly-hidden");
          thumb.classList.remove("swiper-slide-thumb-active");
        }
      } else {
        thumb.classList.remove("onkly-hidden");
        extraFound = true;
      }
    });

    thumbsWrapper.classList.toggle("onkly-thumbs-empty", !extraFound);
    applyMainSliderFilter(root, currentVariant, variantMediaIds, currentMediaId);
    updateSwipers(root);
    markThumbsReady(root);
  }

  // Snapshot the original set of main-slider slides once. We later rebuild
  // the wrapper from this stash, keeping only the active variant's slide
  // plus all non-variant slides (size chart etc.). That way swipe gestures
  // can only navigate between the relevant slides.
  function ensureSlidesStash(root) {
    if (root._onklySlidesStash) return;
    var swiper = getMainSwiper(root);
    if (!swiper || !swiper.wrapperEl) return;
    var slides = Array.from(swiper.wrapperEl.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)"));
    if (!slides.length) return;
    root._onklySlidesStash = slides.map(function (slide) {
      return {
        mediaId: String(slide.getAttribute("data-id")),
        html: slide.outerHTML
      };
    });
  }

  function applyMainSliderFilter(root, currentVariant, variantMediaIds, currentMediaId) {
    if (!currentVariant || !currentVariant.featured_media) return;
    var swiper = getMainSwiper(root);
    if (!swiper) return;

    ensureSlidesStash(root);
    if (!root._onklySlidesStash) return;

    var keep = root._onklySlidesStash.filter(function (s) {
      var isVariantMedia = variantMediaIds.indexOf(s.mediaId) !== -1;
      return !isVariantMedia || s.mediaId === currentMediaId;
    });

    // Skip rebuild if the visible set hasn't changed (avoids flicker on
    // duplicate apply() calls from change + variantChange events).
    var keepSig = keep.map(function (s) { return s.mediaId; }).join(",");
    if (root._onklyLastKeepSig === keepSig) return;
    root._onklyLastKeepSig = keepSig;

    var newSlides = keep.map(function (s, idx) {
      var div = document.createElement("div");
      div.innerHTML = s.html;
      var slide = div.firstElementChild;
      slide.setAttribute("data-slide", idx);
      slide.classList.remove("swiper-slide-active", "swiper-slide-prev", "swiper-slide-next", "swiper-slide-duplicate");
      return slide;
    });

    try {
      swiper.removeAllSlides();
      swiper.appendSlide(newSlides);
      swiper.update();
      swiper.slideTo(0, 0, false);
      attachActiveThumbSync(root);
      syncActiveThumb(root);
    } catch (e) {}
  }

  // After the main slider is rebuilt, slide indices no longer match the
  // original `data-slide` attributes on thumbs. Look up the live index by
  // matching `data-mediaid` (thumb) against `data-id` (slide).
  function findSlideIndexByMediaId(swiper, mediaId) {
    if (!swiper || !mediaId) return -1;
    for (var i = 0; i < swiper.slides.length; i++) {
      if (String(swiper.slides[i].getAttribute("data-id")) === String(mediaId)) return i;
    }
    return -1;
  }

  function syncActiveThumb(root) {
    var swiper = getMainSwiper(root);
    if (!swiper) return;
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    var activeId = String(activeSlide.getAttribute("data-id"));
    root.querySelectorAll(".product-thumb__item").forEach(function (thumb) {
      var mediaEl = thumb.querySelector("[data-mediaid]");
      var mediaId = mediaEl ? String(mediaEl.getAttribute("data-mediaid")) : null;
      thumb.classList.toggle("swiper-slide-thumb-active", mediaId === activeId);
    });
  }

  function handleThumbnailClick(root) {
    root.addEventListener("click", function (e) {
      var thumb = e.target.closest(".product-thumb__item");
      if (!thumb || thumb.classList.contains("onkly-hidden")) return;

      var mediaEl = thumb.querySelector("[data-mediaid]");
      var mediaId = mediaEl ? mediaEl.getAttribute("data-mediaid") : null;
      if (!mediaId) return;

      var mainSwiper = getMainSwiper(root);
      if (!mainSwiper) return;

      var slideIndex = findSlideIndexByMediaId(mainSwiper, mediaId);
      if (slideIndex < 0) return;

      e.preventDefault();
      mainSwiper.slideTo(slideIndex, 0, false);
      syncActiveThumb(root);
    });
  }

  // Keep the active thumb border in sync when the user swipes the main slider.
  // Re-attached after every rebuild because removeAllSlides() drops listeners.
  function attachActiveThumbSync(root) {
    var swiper = getMainSwiper(root);
    if (!swiper) return;
    if (swiper._onklySyncBound) return;
    swiper._onklySyncBound = true;
    swiper.on("slideChange", function () { syncActiveThumb(root); });
  }

  // DESKTOP: predict the variant on pointerdown so the image swaps before the
  // browser fires click. Curtain hides the in-between frame.
  function handleDesktopFastImage(root) {
    if (IS_TOUCH) return;
    document.addEventListener("pointerdown", function (e) {
      if (e.target.closest(".product-thumb__item")) return;

      var input = getClickedInput(e.target);
      if (!input) return;

      var sectionId = getSectionId(root);
      var variants = getVariants(sectionId);
      var options = buildFutureOptions(root, input);
      var futureVariant = findVariantByOptions(variants, options);
      // Fallback: when other groups (e.g. size) are unchecked, options are
      // incomplete and full-match fails. Find any variant matching just the
      // clicked option's value at its position.
      if (!futureVariant) {
        var ci = getOptionIndex(input, root);
        if (ci >= 0) {
          futureVariant = variants.find(function (v) {
            return v && v.options && v.options[ci] === input.value && v.featured_media;
          });
        }
      }
      if (!futureVariant || !futureVariant.featured_media) return;

      var current = getCurrentVariant(sectionId);
      var currentMediaId = current && current.featured_media ? String(current.featured_media.id) : "";
      var futureMediaId = String(futureVariant.featured_media.id);
      if (currentMediaId && currentMediaId === futureMediaId) {
        apply(root, futureVariant);
        return;
      }

      showCurtain(root);
      forceMainImage(root, futureVariant);

      requestAnimationFrame(function () {
        apply(root, futureVariant);
        hideCurtain(root, false);
      });
    }, true);
  }

  // MOBILE / TOUCH: react to the change event AFTER the radio is actually
  // checked. Listening on document (capture phase) — same as the proven
  // diagnostic snippet — guarantees we run before any other handler can
  // interfere with the curtain element.
  function handleTouchVariantChange(root) {
    if (!IS_TOUCH) return;
    var sectionId = getSectionId(root);

    document.addEventListener("change", function (e) {
      var input = e.target;
      if (!input) return;
      if (input.type !== "radio" && input.tagName !== "SELECT") return;
      if (!input.closest("#variant-selects-" + sectionId)) return;

      var variants = getVariants(sectionId);
      var options = buildFutureOptions(root, input);
      var futureVariant = findVariantByOptions(variants, options);
      // Fallback for incomplete options (e.g. size unchecked).
      if (!futureVariant) {
        var ci = getOptionIndex(input, root);
        if (ci >= 0) {
          futureVariant = variants.find(function (v) {
            return v && v.options && v.options[ci] === input.value && v.featured_media;
          });
        }
      }
      if (!futureVariant) return;

      var current = getCurrentVariant(sectionId);
      var currentMediaId = current && current.featured_media ? String(current.featured_media.id) : "";
      var futureMediaId = futureVariant.featured_media ? String(futureVariant.featured_media.id) : "";
      if (currentMediaId && futureMediaId && currentMediaId === futureMediaId) {
        apply(root, futureVariant);
        return;
      }

      showCurtain(root);

      setTimeout(function () {
        forceMainImage(root, futureVariant);
        apply(root, futureVariant);
      }, 60);
    }, true);
  }

  // Replace the brittle 50/300/900ms timeouts with a one-shot observer.
  function whenThumbsReady(root, cb) {
    if (root.querySelector(".product-thumb__item")) { cb(); return; }
    var done = false;
    var finish = function () { if (done) return; done = true; obs.disconnect(); cb(); };
    var obs = new MutationObserver(function () {
      if (root.querySelector(".product-thumb__item")) finish();
    });
    obs.observe(root, { childList: true, subtree: true });
    setTimeout(finish, 1500);
  }

  // Wait until Avone has fully initialised the main swiper. Without this the
  // first apply() call runs too early — stash stays empty, filter never kicks
  // in, and all images remain swipeable until the user clicks a swatch.
  function whenSwiperReady(root, cb) {
    if (getMainSwiper(root)) { cb(); return; }
    var done = false;
    var finish = function () { if (done) return; done = true; clearInterval(timer); cb(); };
    var timer = setInterval(function () { if (getMainSwiper(root)) finish(); }, 100);
    setTimeout(finish, 3000);
  }

  function boot() {
    var root = getRoot();
    if (!root) return;

    whenThumbsReady(root, function () {
      whenSwiperReady(root, function () { apply(root); });
    });

    handleThumbnailClick(root);
    handleDesktopFastImage(root);
    handleTouchVariantChange(root);

    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var d = (payload && payload.data) || {};
        if (String(d.sectionId) !== String(getSectionId(root))) return;
        apply(root, d.variant || null);
        hideCurtain(root, false);
        // Re-sync active thumb after Avone's own logic finishes — Avone may
        // strip/replace the active class on its thumbnail swiper.
        setTimeout(function () { syncActiveThumb(root); }, 100);
        setTimeout(function () { syncActiveThumb(root); }, 400);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
